module.exports = __webpack_public_path__ + "static/image9-e9b7885c962c6119c877adb6725c4b4b.png";